var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 291,
    height: 193,
    viewBox: "0 0 291 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6225 151.999C57.5654 151.999 59.1405 150.432 59.1405 148.5C59.1405 146.567 57.5654 145 55.6225 145C53.6796 145 52.1045 146.567 52.1045 148.5C52.1045 150.432 53.6796 151.999 55.6225 151.999Z",
    fill: "#FF9649"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9244 185.909L71.1163 187.753L73.1079 188.085L71.2959 188.971L72.6018 190.497L70.6429 190.018L70.6592 192.032L69.4675 190.408L68.1778 191.959L68.3166 189.953L66.325 190.318L67.7207 188.873L65.9658 187.882L67.9738 187.663L67.2718 185.779L68.9451 186.892L69.6226 185L70.1858 186.932L71.9244 185.909Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.492 31.544L55.0104 32.632L56.1939 32.8269L55.1165 33.3547L55.8919 34.256L54.7329 33.9718L54.741 35.1654L54.0391 34.1991L53.28 35.1167L53.3534 33.9312L52.178 34.1504L53.0024 33.2897L51.9658 32.7051L53.1575 32.5752L52.7331 31.4628L53.7289 32.1205L54.1289 31L54.4635 32.1449L55.492 31.544Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M247.492 70.544L247.01 71.632L248.194 71.8269L247.117 72.3547L247.892 73.256L246.733 72.9718L246.741 74.1654L246.039 73.1991L245.28 74.1167L245.353 72.9312L244.178 73.1504L245.002 72.2897L243.966 71.7051L245.158 71.5752L244.733 70.4628L245.729 71.1205L246.129 70L246.464 71.1449L247.492 70.544Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.116 45.4615L225.957 47.597L228.006 48.9124L225.606 49.3427L225.843 51.7543L224.014 50.1547L222.268 51.8436L222.382 49.4239L219.966 49.1235L221.941 47.7026L220.668 45.632L223.019 46.2816L223.859 44L224.806 46.2329L227.116 45.4615Z",
    fill: "#C2CAD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M253.382 33.3872L251.497 36.8624L254.827 39.0141L250.917 39.7124L251.309 43.6504L248.321 41.0359L245.473 43.7966L245.661 39.8423L241.71 39.347L244.934 37.0329L242.869 33.6551L246.697 34.7188L248.06 31L249.611 34.6376L253.382 33.3872Z",
    fill: "#FF9649"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81.4658,
    cy: 2.5,
    r: 2.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 230.466,
    cy: 171.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.966,
    cy: 121,
    r: 1,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.03516,
    cy: 141,
    r: 1,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.234359d83d4f834520544572e9e162e3.svg";
export { ForwardRef as ReactComponent };